import { Box, BoxProps } from '@razorpay/blade/components';
import React, { PropsWithChildren } from 'react';

const ComponentContainer = ({ children, ...props }: PropsWithChildren<BoxProps>) => {
  return (
    <Box
      display={'flex'}
      flexDirection={'column'}
      gap={'44px'}
      marginBottom={'spacing.8'}
      {...props}>
      {children}
    </Box>
  );
};

export default ComponentContainer;
